/* global jQuery */

export default function notify(message, type) {
  jQuery.notify(
    {
      message: message,
    },
    {
      type: type || 'success',
      placement: { from: 'top', align: 'center' },
      allow_dismiss: true,
      offset: 11,
    },
  );
}

window.notify = notify;
